const InitFocusStyles = () => {
    // A copy of Facebook's approach to handling focus styles for keyboard vs mouse users
    document.body.addEventListener('mousedown', () => {
        document.body.classList.add('using-mouse');
    });
    // Note this currently triggers for 'ANY' keyboard use, including alt-tabbing to another window
    document.body.addEventListener('keydown', () => {
        document.body.classList.remove('using-mouse');
    });
};

export default InitFocusStyles;
